import { render } from "./OapPageNavigation.vue?vue&type=template&id=025f74c2"
import script from "./OapPageNavigation.vue?vue&type=script&lang=js"
export * from "./OapPageNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__